/* DD upsell (Namie): stamp _dd_upsell = <SKU> when an upgrade (Tray) variant is added via the
   product form dropdown. Capture phase so the hidden input exists before <product-form> reads the form.
   Skips if the add was claimed by the ATC popup (which stamps _atc_upsell) to avoid double-attribution. */
(function () {
  var el = document.querySelector('[data-dd-upsell-map]');
  if (!el) return;
  var MAP;
  try { MAP = JSON.parse(el.textContent); } catch (e) { return; }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;
    var sku = MAP[input.value];
    if (!sku) return;
    var atc = form.querySelector('input[name="properties[_atc_upsell]"]');
    if (atc && atc.value) return; // ATC upgrade already attributed this add
    var prop = form.querySelector('input[name="properties[_dd_upsell]"]');
    if (!prop) { prop = document.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[_dd_upsell]'; form.appendChild(prop); }
    prop.value = sku;
  }, true);
})();
